'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _glamor = require('glamor');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _Prompt = require('@quixeltools/quixel-ui-library/dist/components/bridge/popups/Prompt');

var _Prompt2 = _interopRequireDefault(_Prompt);

var _IconWithDescription = require('@quixeltools/quixel-ui-library/dist/components/megascans/marketing/IconWithDescription');

var _IconWithDescription2 = _interopRequireDefault(_IconWithDescription);

var _IconWithDescriptionAndLink = require('@quixeltools/quixel-ui-library/dist/components/megascans/marketing/IconWithDescriptionAndLink');

var _IconWithDescriptionAndLink2 = _interopRequireDefault(_IconWithDescriptionAndLink);

var _IconWithDescriptionAndLinkInColumn = require('@quixeltools/quixel-ui-library/dist/components/megascans/marketing/IconWithDescriptionAndLinkInColumn');

var _IconWithDescriptionAndLinkInColumn2 = _interopRequireDefault(_IconWithDescriptionAndLinkInColumn);

var _user = require('../../redux/modules/user');

var _fonts = require('@quixeltools/quixel-ui-library/dist/utils/fonts');

var _TopBanner = require('@quixeltools/quixel-ui-library/dist/components/megascans/marketing/TopBanner');

var _TopBanner2 = _interopRequireDefault(_TopBanner);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listPromotion = [{
  logo: 'https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/megascans_icon_2048_preview.png',
  title: 'Megascans',
  description: 'Access to the free section of the world’s largest and fastest growing scan library.',
  link: {
    to: '',
    newWindow: true,
    iconType: 'download',
    linkLable: 'download now'
  }
}, {
  logo: 'https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/bridge_icon_2048.png',
  // title:'Bridge',
  description: 'The complete management and integrations solution.'
}, {
  logo: 'https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/mixer_icon_2048_preview.png',
  // title:'Mixer',
  description: 'Blend, paint & sculpt tileable materials in no-time.'
}];

var listing = (0, _glamor.css)({
  marginBottom: 48,
  flexBasis: '33.33%',
  ':last-child': {
    marginBottom: 0
  }
});

var p = (0, _glamor.css)(_fonts.popupTextbtn, {
  marginBottom: '50px'
});

var container = (0, _glamor.css)({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between'
});

var textButtonStyle = (0, _glamor.css)({
  textDecoration: 'underline',
  color: 'white',
  '& a': {
    fontWeight: '700'
  }
});

var LibraryTopBanner = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    activating: state.user.activatingTrial,
    activated: state.user.activatedTrial,
    error: state.user.trialError,
    megascansTrial: state.user.megascansTrial,
    subscription: state.user.subscription
  };
}, { activateTrial: _user.activateTrial }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(LibraryTopBanner, _React$Component);

  function LibraryTopBanner(props) {
    (0, _classCallCheck3.default)(this, LibraryTopBanner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LibraryTopBanner.__proto__ || (0, _getPrototypeOf2.default)(LibraryTopBanner)).call(this, props));

    _this.state = {
      message: null,
      error: null,
      trailLeft: {
        words: '',
        days: 100
      },
      close: false
    };

    _this.onCloseHandler = _this.onCloseHandler.bind(_this);
    _this.makePositive = _this.makePositive.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(LibraryTopBanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_underscore2.default.isEmpty(this.props.megascansTrial)) {
        var a = (0, _moment2.default)(this.props.megascansTrial.expiresAt);
        var b = (0, _moment2.default)();

        var dayDif = a.diff(b, 'days');

        this.setState({
          trailLeft: {
            words: a.fromNow(),
            days: dayDif,
            seconds: a.diff(b, 'seconds')
          }
        });

        if (window.localStorage.getItem('libraryPopupOpen') === 'true') {
          this.setState({
            close: false
          });
        }

        var tempOldDate = parseInt(window.localStorage.getItem('closeLibraryPopup'));

        if (!tempOldDate || this.makePositive(this.makePositive(dayDif) - tempOldDate) >= 1) {
          this.setState({
            close: false
          });
          window.localStorage.setItem('libraryPopupOpen', true);
        } else {
          this.setState({
            close: true
          });
          window.localStorage.setItem('libraryPopupOpen', false);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!_underscore2.default.isEmpty(nextProps.megascansTrial) && nextProps.megascansTrial !== this.props.megascansTrial) {

        var a = (0, _moment2.default)(nextProps.megascansTrial.expiresAt);
        var b = (0, _moment2.default)();

        var dayDif = a.diff(b, 'days');

        this.setState({
          trailLeft: {
            words: a.fromNow(),
            days: dayDif,
            seconds: a.diff(b, 'seconds')
          }
        });

        var tempOldDate = parseInt(window.localStorage.getItem('closeLibraryPopup'));

        if (!tempOldDate || this.makePositive(this.makePositive(dayDif) - tempOldDate) >= 1) {
          this.setState({
            close: false
          });
          window.localStorage.setItem('libraryPopupOpen', true);
        } else {
          this.setState({
            close: true
          });
          window.localStorage.setItem('libraryPopupOpen', false);
        }
      }
    }
    // shouldComponentUpdate(nextProps,nextState){
    //   if(this.state.close !== nextState.close){
    //     let a = moment(nextProps.megascansTrial.expiresAt);
    //     let b = moment();
    //
    //     let dayDif = a.diff(b,'days');
    //
    //
    //     this.setState({
    //       trailLeft:{
    //         words:a.fromNow(),
    //         days:dayDif,
    //         seconds:a.diff(b,'seconds'),
    //       }
    //     })
    //
    //     let tempOldDate = parseInt(window.localStorage.getItem('closeLibraryPopup'));
    //
    //
    //     if(this.makePositive(this.makePositive(dayDif)-tempOldDate)>=1){
    //       this.setState({
    //         close:false
    //       })
    //       window.localStorage.setItem('libraryPopupOpen', true);
    //     }
    //     else{
    //       this.setState({
    //         close:true
    //       })
    //       window.localStorage.setItem('libraryPopupOpen', false);
    //     }
    //     return true;
    //   }
    // }
    //

  }, {
    key: 'makePositive',
    value: function makePositive(numb) {
      return numb < 0 ? -numb : numb;
    }
  }, {
    key: 'onCloseHandler',
    value: function onCloseHandler() {
      this.setState({
        close: true
      });

      window.localStorage.setItem('closeLibraryPopup', this.state.trailLeft.days);
      window.localStorage.setItem('libraryPopupOpen', false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          megascansTrial = _props.megascansTrial,
          subscription = _props.subscription;

      if (!_underscore2.default.isEmpty(megascansTrial)) {

        return this.state.trailLeft.days <= 7 && !this.state.close && !(subscription && subscription.isActive) && _react2.default.createElement(_TopBanner2.default, {
          containerStyles: (0, _glamor.css)({ position: 'initial' }),
          message: megascansTrial.isActive ? 'TRIAL EXPIRES ' + this.state.trailLeft.words + '. FIND THE RIGHT PLAN FOR YOU.' : 'YOUR TRIAL HAS EXPIRED. FIND THE RIGHT PLAN FOR YOU.',
          textButtonTo: '/pricing',
          textButtonLabel: 'SUBSCRIBE',
          textButtonStyle: textButtonStyle,
          onDiscard: this.onCloseHandler
        });
      } else {
        return null;
      }
    }
  }]);
  return LibraryTopBanner;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react.PropTypes.object
}, _temp)) || _class);
exports.default = LibraryTopBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LibraryTopBanner/LibraryTopBanner.jsx
// module id = 2631
// module chunks = 0